module.exports = __webpack_public_path__ + "static/logo2-a8a3d7abacc3357c260f3dbc7dc5d838.svg";